module.exports = __webpack_public_path__ + "static/media/funcesp-logo.4679a1c6.png";